/* Consent-gated top-window GTM bootstrap. Does not change the existing consent state. */
(() => {
  'use strict';
  if (window.__caenePdpGtmBootstrap) return;
  const id = document.currentScript?.dataset.containerId;
  if (!/^GTM-[A-Z0-9]+$/.test(id || '')) return;
  window.__caenePdpGtmBootstrap = true;
  let requested = false;
  function load() {
    if (requested || !document.querySelector('[data-track-pdp]')) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
    } catch (_) { return; }
    if (window.google_tag_manager?.[id] || [...document.scripts].some(script => {
      if (!script.src) return false;
      try { const url = new URL(script.src); return url.hostname === 'www.googletagmanager.com' && url.pathname === '/gtm.js' && url.searchParams.get('id') === id; }
      catch (_) { return false; }
    })) { requested = true; return; }
    requested = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'gtm.start':Date.now(), event:'gtm.js'});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + id;
    document.head.appendChild(script);
  }
  function boot() {
    load();
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],load);
    }
  }
  document.addEventListener('visitorConsentCollected',load);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
